// This file is kept for legacy compatibility but API configuration is now handled at runtime
// See app.config.ts for actual runtime environment detection based on hostname

export const environment: {
    production: boolean;
    apiBaseUrl: string;
    isLocalBackend: boolean;
} = {
    production: true,
    apiBaseUrl: '', // Not used - runtime configuration handles API URLs
    isLocalBackend: false // Production never uses local backend
};
